module.exports = __webpack_public_path__ + "img/Lady_completed.daa2c001.svg";